import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { SketchPicker } from 'react-color';
import Tippy from '@tippyjs/react';
import apiConnect from '../../../config/apiConfig';
import style from './standConfig.module.scss';

const StandConfigMenu = ({ stand, images, id, colorStand, setColorStand }) => {
  const {
    containerLeft,
    formLayout,
    formInput,
    formLabel,
    buttonColor,
    circleColor,
    btnSubmit,
    messageStyle
  } = style;

  const [formData, setFormData] = useState({});

  const history = useHistory();
  
  const onFinish = async () => {
    const body = {
      ...images,
      ...formData,
      standColor: colorStand,
    };

    try {
      
      message.info({
        content: 'Espere un momento por favor...',
        icon: <LoadingOutlined/>,
        className: messageStyle
      });
      
      await apiConnect.put(`/stands/${id}`, body);

      message.success({
        content: 'El stand se editó con éxito.',
        className: messageStyle
      });

      setTimeout(() => {
        history.push('/provider');
      }, 1500);

    } catch(error) {
      message.error({
        content: 'Hubo un problema, vuelva a intentarlo más tarde.',
        className: messageStyle
      });
    }

  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed: ', errorInfo) // eslint-disable-line
  };

  const handleFormChange = (e, inpName) => {
    setFormData({
      ...formData,
      [inpName]: e.target.value
    });
  };

  return (
    <div className={containerLeft}>
      <h2>Configurar Stand</h2>
      <div>
        <Form
          className={formLayout}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <span className={formLabel}>Nombre de stand</span>
          <Form.Item
            onChange={e => handleFormChange(e, 'name')}
            rules={[
              {
                required: true,
                message: 'Ingrese un nombre.'
              }  
            ]}
          >
            <Input
              className={formInput}
              placeholder='Nombre del stand'
              defaultValue={stand.name}
            />
          </Form.Item>

          <span className={formLabel}>Facebook (anteponer https://)</span>
          <Form.Item
            onChange={e => handleFormChange(e, 'facebookLink')}
            rules={[
              {
                required: false,
              }  
            ]}
          >
            <Input
              className={formInput}
              placeholder='Ej: https://www.facebook.com/usuario'
              defaultValue={stand.facebookLink}
            />
          </Form.Item>

          <span className={formLabel}>Instagram (anteponer https://)</span>
          <Form.Item
            value={stand.instagramLink || ''}
            onChange={e => handleFormChange(e, 'instagramLink')}
            rules={[
              {
                required: false,
              }  
            ]}
          >
            <Input
              className={formInput}
              placeholder='Ej: https://www.instagram.com/usuario'
              defaultValue={stand.instagramLink}
            />
          </Form.Item>

          <span className={formLabel}>Sitio web (anteponer https://)</span>
          <Form.Item
            value={stand.webLink || ''}
            onChange={e => handleFormChange(e, 'webLink')}
            rules={[
              {
                required: false,
              }  
            ]}
          >
            <Input
              className={formInput}
              placeholder='Ej: https://www.sitio-web.com'
              defaultValue={stand.webLink}
            />
          </Form.Item>

          <Form.Item
            hidden={stand.type === 'standard' && true}
          >
            <span className={formLabel}>Color</span>
            <Tippy
              interactive={true}
              placement={'top'}
              content={
                <SketchPicker
                  color={colorStand}
                  onChangeComplete={ color => setColorStand(color.hex)}
                />
              }
            >
              <Button
                className={buttonColor}
              >
                <span className={circleColor} style={{ background: colorStand}}/>
                <span>{colorStand}</span>
              </Button>
            </Tippy>
          </Form.Item>
          <Form.Item>
            <Button
              className={btnSubmit}
              htmlType="submit"
            >
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default StandConfigMenu;